meedy.controller('meedy.patientOrderFilesPopupController', ['$rootScope', '$scope', '$mdDialog', '$translate', 'meedy.mdxOrderModel', 'icrOrderId', 'term','title',
    function ($rootScope, $scope, $mdDialog, $translate, mdxOrderModel, icrOrderId, term, title) {

        function setData() {
            $scope.Enum = Enum;

            $scope.title = title;
            $scope.icrOrderId = icrOrderId;
            $scope.term = term;

            $scope.hideFiles = !$scope.term.claimDetails.status || $scope.term.claimDetails.status==Enum.MDX_ORDER_STATUS.FINISHED;

            $scope.orderDetails = null;
            $scope.orderStatus = null;
            $scope.orderFiles = [];
            $scope.numberOfPages = 0;
            $scope.criteria =
                {
                    "sortColumns": [
                        {
                            "columnName": "fileAddedDate",
                            "descending": true
                        }
                    ],
                    "pageNumber": 0,
                    "rowsPerSheet": 10,
                    "idOrder": icrOrderId,
                    "withAssociatedFiles": false
                };

            $scope.selected = [];
        }

        function setGrid() {

            $scope.columns = [
                {
                    field: "name",
                    displayName: $translate.instant('T.MEEDY.MODULE.ORDER_FILES_POPUP.FILE_NAME')
                },
                {
                    field: "fileSize | meedyFileSize",
                    displayName: $translate.instant('T.MEEDY.MODULE.ORDER_FILES_POPUP.FILE_SIZE')
                },
                {
                    field: "fileAddedDate | date:'dd.MM.yyyy HH:mm'",
                    displayName: $translate.instant('T.MEEDY.MODULE.ORDER_FILES_POPUP.FILE_ADDED_DATE'),
                },
                {
                    field: "'T.MEEDY.ENUM.MDX_SCAN_STATUS.' + fileScanStatus | translate",
                    displayName: $translate.instant('T.MEEDY.MODULE.ORDER_FILES_POPUP.FILE_SCAN_STATUS'),
                }
            ];

            $scope.buttons = [
                {
                    icon: 'content:add',
                    action: 'uploadFiles',
                    filesSelect: true
                },
                {
                    label: $translate.instant('T.MEEDY.MODULE.ORDER_FILES_POPUP.DOWNLOAD'),
                    action: 'downloadOriginalFile'
                },
                {
                    label: $translate.instant('T.MEEDY.MODULE.ORDER_FILES_POPUP.DOWNLOAD_MERGED'),
                    action: 'downloadMergeFile'
                }
                // Removed because MDX doesn't provide
                // ,{
                //     label: $translate.instant('T.MEEDY.MODULE.ORDER_FILES_POPUP.DELETE'),
                //     action: 'deleteFiles'
                // }
            ];
        }

        function setPermissions() {
        }

        function setListeners() {

        }

        function setActions() {

            $scope.downloadOriginalFile = function () {
                if ($scope.hideFiles) return;
                if ($scope.selected.length == 1) {
                    mdxOrderModel.downloadFile($scope.icrOrderId, $scope.selected[0].id);
                } else if ($scope.selected.length > 1) {
                    mdxOrderModel.downloadMergedFiles($scope.icrOrderId, $scope.selected.map(function (file) {
                        return file.id;
                    }), Enum.MDX_FILE_TYPE.ZIP_ARCHIVE_EVENT_FILES);
                }
            };

            $scope.downloadMergeFile = function () {
                if ($scope.hideFiles) return;
                mdxOrderModel.downloadMergedFiles(
                    $scope.icrOrderId,
                    $scope.selected.map(function (file) {
                        return file.id;
                    }),
                    Enum.MDX_FILE_TYPE.MERGED_ORDER_FILES
                );
            };

            $scope.uploadFiles = function (enclosedFiles) {
                if ($scope.hideFiles) return;
                if (enclosedFiles.length) {
                    mdxOrderModel.uploadFiles($scope.icrOrderId, enclosedFiles)
                        .then(function (uploadedFiles) {
							sendUploadedFilesEmail (uploadedFiles);
                            getFilesList();
                        })
                        .catch(function (uploadedFilesInfo) {
                            sendUploadedFilesEmail (uploadedFilesInfo.uploadedFiles);
                            getFilesList();
                        });
                }

            };
            
            function sendUploadedFilesEmail (uploadedFiles) {
                if(uploadedFiles && uploadedFiles.length>0) {
					var fileNamesString = _.map(uploadedFiles, 'name').join(', ');
                    mdxOrderModel.sendFileAttachedEmail(
                        _.assign(new MdxSendFileAttachedEmailVO(),
                            {
                                idOrder: $scope.icrOrderId,
                                fileName: fileNamesString
                            }
                        )
                    );
                }
            }

            $scope.deleteFiles = function () {
                if ($scope.hideFiles) return;
                if ($scope.selected.length) {
                    mdxOrderModel.deleteFiles(_.map($scope.selected, 'id'))
                        .then(function (data) {
                            getFilesList();
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
            };


            $scope.criteriaChanged = function () {
                getFilesList();
            };

            $scope.cancel = function () {
                $mdDialog.cancel();
            };
        }

        function configureInterface() {

        }

        function initialize() {
            getFilesList();
            getOrderDetails();
        }


        function getFilesList() {
            if(!$scope.hideFiles) {
                mdxOrderModel.getOrderFiles($scope.criteria)
                    .then(function (orderFiles) {
                        $scope.orderFiles = orderFiles.data;
                        $scope.numberOfPages = orderFiles.numberOfPages;
                    })
                    .catch(function (error) {
                        $scope.orderFiles = [];
                    });
            }
        }


        function getOrderDetails() {
            mdxOrderModel.getOrderDetails($scope.icrOrderId)
                .then(function (orderDetails) {
                    $scope.orderDetails = orderDetails;
                    $scope.orderStatus = $translate.instant('T.MEEDY.ENUM.MDX_ORDER_STATUS.' + orderDetails.mdxStatus['com.es.mdx.model.type.OrderStatusReasonType']);
                })
                .catch(function (error) {
                    $scope.orderDetails = null;
                });

        }

        setData();
        setPermissions();
        setGrid();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
